export default __webpack_public_path__ + "static/03.10-9447997db36449c9f8b79c890460e330.png";